import { ReducerGraphic, ReduxActionData } from '../../types/reducers'
import { Languages } from '../../utility/Languages'
import { GRAPHIC_ACTIONS } from '../actions/graphic'

const initialState: ReducerGraphic = {
    currentLanguage: Languages.italian,
}

const graphicState: (state: ReducerGraphic, action: ReduxActionData<any, GRAPHIC_ACTIONS>) => ReducerGraphic = (
    // eslint-disable-next-line default-param-last
    state = initialState,
    action: ReduxActionData<any, GRAPHIC_ACTIONS>
) => {
    switch (action.type) {
        case GRAPHIC_ACTIONS.SET_CURRENT_LANGUAGE:
            return {
                ...state,
                currentLanguage: action.payload,
            }
        default:
            return state
    }
}

export default graphicState
